import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { _post } from "../configs/api-config";
import { IAffilateBody, IAffilateRequest, ThemeOptionsType } from "../types";
import { _getAffiliate } from "../commonFunction";
import { VIPER_CONST } from "../commonConstant";
import AffiApi from "../api/affiliate-theme-api";
import { defaultThemeOptions } from "../defaultTheme";
import { RootState } from "../app/store";

const initialState: IAffilateRequest = {
  affiliateid: null,
  affiliatename: "",
  loading: false,
  error: null,
  status: null,
  preview: null,
  affiliates: []
};

export const affiliate = createAsyncThunk(
  "affiliate/getOne",
  async (request: IAffilateBody, thunkApi) => {
    try {
      const responseData = await AffiApi.affilateData(request);
      return thunkApi.fulfillWithValue({ ...responseData, ...request });
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const fetchAffiliateData = createAsyncThunk(
  "affiliate/getAll",
  async (request: IAffilateBody, thunkApi) => {
    try {
      const responseData = await AffiApi.affilateData(request);
      const idName = responseData?.data?.affiliates
      await _getAffiliate(idName)
      return thunkApi.fulfillWithValue({ ...responseData, ...request });
    } catch (error) {
      throw thunkApi.rejectWithValue(error);
    }
  }
);


const affiliateSlice = createSlice({
  name: "affiliate theme",
  initialState,
  reducers: {
    clearAffiliate: (state) => {
      state.affiliateid = null;
      state.affiliatename = "";
      state.preview = defaultThemeOptions as ThemeOptionsType;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(affiliate.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(affiliate.fulfilled, (state, action) => {
      state.loading = false;
      state.status = action.payload.status?.toString() ?? null;
      state.affiliateid = action.payload.data?.affiliates[0].affiliateid ?? null;
      state.affiliatename = action.payload.data?.affiliates[0].affiliatename ?? "";
      state.preview = action.payload.data?.affiliates[0].theme.preview ?? null;
    });
    builder.addCase(affiliate.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    })

      .addCase(fetchAffiliateData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAffiliateData.fulfilled, (state, action) => {
        state.loading = false;
        state.affiliates = action.payload.data?.affiliates;
      })
      .addCase(fetchAffiliateData.rejected, (state) => {
        state.loading = false;
      })
  },
});

export const affiliateid = affiliateSlice.actions;
export const affiliateDataId = (state: RootState) => state.affiliateData.affiliateid;

export const { clearAffiliate } = affiliateSlice.actions;

export const affiliateName = (state: RootState) => state.affiliateData.affiliatename;
export default affiliateSlice.reducer;
